module.exports = __webpack_public_path__ + "img/arrow-circle-right-outline-blue.52781142.svg";